import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import useAuth from '../hooks/useAuth';
import { PATHS } from '../routes/paths';

interface ProtectedRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

export default function ProtectedRoute({
  children,
  redirectTo = PATHS.jobPortal.root,
}: ProtectedRouteProps) {
  const { verifiedInfo } = useAuth();

  if (!verifiedInfo) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
